import { isEmpty } from 'lodash';
import { getUbiServicesEndpoint } from '@sitegen/common/utils/ubi-services';
import URLParams from 'utils/url-params';

import { PLATFORM_DISPLAY_PROPS } from 'constants/platforms-display-props';
import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';
import { REDEMPTION_ENDPOINT } from './redemption.constants';

import { IProfilePlatform, IProfilePlatforms } from 'types/profiles';
import { PLATFORM_URL_PARAMETER } from 'constants/platform';

export const buildRedemptionURL = (envName: string) => `${getUbiServicesEndpoint(envName)}${REDEMPTION_ENDPOINT}`;

export const isProfilePlatformLinkable = (profilePlatform: IProfilePlatform): boolean => {
    if (!profilePlatform) {
        return false;
    }

    return PLATFORM_DISPLAY_PROPS[profilePlatform.id].isLinkable;
};

export const getPlatformFromURL = () => {
    const platformURLParameter = URLParams().get(PLATFORM_URL_PARAMETER) || '';
    return platformURLParameter.toUpperCase();
};

export const getProfilePlatformById = (platformId: PLATFORM_TYPES | null, profilePlatforms: IProfilePlatforms): IProfilePlatform | null => {
    if (!platformId) {
        return null;
    }
    return profilePlatforms.find(profilePlatform => profilePlatform.id === platformId) || null;
};

/* We suppress the error here because we have not yet there interface for the store */
// @ts-ignore
export const isAdditionalInfoRequired = (state): boolean => {
    const additionalDetailsArray = state.redemption?.additionalDetailsDefinition;

    if (additionalDetailsArray) {
        const additionalRedeemDetailWithoutPlatforms = state.redemption?.additionalDetailsDefinition ?? [];

        return !isEmpty(additionalRedeemDetailWithoutPlatforms);
    }

    return false;
};
